import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import { useToast } from "../../../contexts/ToastContext";

export function TenantDetailsViewModel(logout, tenantId) {
  const { showSuccess, showError } = useToast();
  const [loading, setLoading] = useState(false);
  const [tenant, setTenant] = useState({});

  const getTenant = async function () {
    setLoading(true);
    const callResult = await makeGetApiCall(`admin/tenants/${tenantId}`);
    if (callResult.success) {
      setTenant(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to load the tenant.");
    }
    setLoading(false);
  };

  const createTenant = async function (values) {
    const callResult = await makePostApiCall(`admin/tenants`, values);

    if (callResult.success) {
      showSuccess(callResult.data.message || "Tenant created successfully.");
      window.location = "/tenants/" + callResult.data.data.id;
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to create the tenant.");
    }
  };

  const updateTenant = async function (values) {
    const callResult = await makePutApiCall(`admin/tenants/${tenantId}`, values);

    if (callResult.success) {
      setTenant(callResult.data.data);
      showSuccess(callResult.data.message || "Tenant updated successfully.");
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
      showError(callResult.data?.message || "Unable to update the tenant.");
    }
  };

  return {
    createTenant,
    updateTenant,
    getTenant,
    tenant,
    loading,
  };
}
